"use client";
import {
  __spreadValues
} from "../../chunk-MMUBH76A.js";
import { createStore, useStore as useZustandStore } from "zustand";
import { createClientSlice, createModalSlice, createWalletSlice } from "./slices/index.js";
import { createJSONStorage, persist } from "zustand/middleware";
const vanillaStore = createStore()(
  persist(
    (...a) => __spreadValues(__spreadValues(__spreadValues({}, createClientSlice(...a)), createModalSlice(...a)), createWalletSlice(...a)),
    {
      version: 1,
      name: "@PARA/web-state",
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        selectedWalletId: state.selectedWalletId,
        selectedWalletType: state.selectedWalletType
      })
    }
  )
);
const createBoundedUseStore = (store) => (selector) => useZustandStore(store, selector);
const useStore = createBoundedUseStore(vanillaStore);
export {
  useStore,
  vanillaStore
};
